import script from "./OAuthCallback.vue?vue&type=script&setup=true&lang=ts"
export * from "./OAuthCallback.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__